import React from 'react';
import { Link, useLocation } from 'react-router-dom'
import { cn } from '../../lib/utils'
import { dashboards } from '../../data/dashboards'
import {
  Users,
  Building2,
  MapPin,
  Calendar,
  Star,
  FileText,
  Settings,
  BarChart3,
  CreditCard,
  MessageSquare,
  Newspaper,
  LayoutDashboard,
} from 'lucide-react'

const mainNavigation = [
  {
    name: 'Users',
    href: '/admin/users',
    icon: Users,
  },
  {
    name: 'Leads',
    href: '/admin/leads',
    icon: Users,
  },
  {
    name: 'Operators',
    href: '/admin/operators',
    icon: Building2,
  },
  {
    name: 'Locations',
    href: '/admin/locations',
    icon: MapPin,
  },
  {
    name: 'Services',
    href: '/admin/services',
    icon: CreditCard,
  },
  {
    name: 'Memberships',
    href: '/admin/memberships',
    icon: CreditCard,
  },
  {
    name: 'Bookings',
    href: '/admin/bookings',
    icon: Calendar,
  },
  {
    name: 'Reviews',
    href: '/admin/reviews',
    icon: Star,
  },
  {
    name: 'Blog',
    href: '/admin/blogs',
    icon: Newspaper,
  },
  {
    name: 'Support',
    href: '/admin/support',
    icon: MessageSquare,
  },
  {
    name: 'Settings',
    href: '/admin/settings',
    icon: Settings,
  },
]

const NavLink = ({ item, pathname }: { item: { href: string; name: string; icon: React.ElementType }; pathname: string }) => {
  const isActive = pathname.startsWith(item.href)
  return (
    <Link
      to={item.href}
      className={cn(
        'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
        isActive
          ? 'bg-muted text-primary'
          : 'text-muted-foreground hover:bg-muted/50 hover:text-primary'
      )}
    >
      <item.icon className="h-5 w-5" />
      <span className="truncate">{item.name}</span>
    </Link>
  )
}

const DashboardNavLink = ({ item, pathname }: { item: { path: string; name: string; icon: React.ElementType }; pathname: string }) => {
  const isActive = pathname.startsWith(item.path)
  return (
    <Link
      to={item.path}
      className={cn(
        'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
        isActive
          ? 'bg-muted text-primary'
          : 'text-muted-foreground hover:bg-muted/50 hover:text-primary'
      )}
    >
      <item.icon className="h-5 w-5" />
      <span className="truncate">{item.name}</span>
    </Link>
  )
}

export function AdminSidebar() {
  const location = useLocation()

  return (
    <div className="flex h-full flex-col gap-2 py-4 bg-white dark:bg-zinc-900 border-r border-gray-200 dark:border-zinc-800 min-w-[16rem]">
      <div className="px-3 py-2">
        <h2 className="mb-2 px-4 text-lg font-semibold tracking-tight">
          Admin Panel
        </h2>
        
        <div className="space-y-1">
          <NavLink item={{ name: 'Overview', href: '/admin/dashboards', icon: LayoutDashboard }} pathname={location.pathname} />
        </div>
      </div>
      
      <div className="px-3 py-2">
         <h2 className="mb-2 px-4 text-sm font-semibold tracking-tight text-muted-foreground">
          Dashboards
        </h2>
        <div className="space-y-1">
          {dashboards.map((item) => (
            <DashboardNavLink key={item.name} item={item} pathname={location.pathname} />
          ))}
        </div>
      </div>

      <div className="px-3 py-2">
        <h2 className="mb-2 px-4 text-sm font-semibold tracking-tight text-muted-foreground">
          Management
        </h2>
        <div className="space-y-1">
          {mainNavigation.map((item) => (
            <NavLink key={item.name} item={item} pathname={location.pathname} />
          ))}
        </div>
      </div>
    </div>
  )
} 